import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2",
      class: "_mb-6"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionWhyUsTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_box, {
      content: true,
      class: "gfu-box gfu-box--flat gfu-box--huge"
    }, {
      content: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.sectionID,
            class: "_grid _grid-cols-1 _grid-cols-2--l _gap-6 _ai-c"
          }, [
            _createVNode(_component_themed_image, {
              src: section.image,
              alt: section.header
            }, null, 8 /* PROPS */, ["src", "alt"]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: paragraph,
                  class: "_mt-3 gfu-bt--b1"
                }, _toDisplayString(paragraph), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}